import { useCompactViewport } from './useCompactViewport';

/** Highcharts tooltips are desktop-only; disabled on mobile and tablet (≤1024px). */
export function useChartTooltipsEnabled() {
  return !useCompactViewport();
}
